import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon } from 'lucide-react';
export function FlatTireRepairPage() {
  return <div data-id="element-1044">
      {/* Page Header */}
      <div className="relative py-24 px-4 sm:px-6 lg:px-8 text-center overflow-hidden bg-black" data-id="element-1045">
        <img src="https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?w=1600&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-25" data-id="element-1046" />
        <div className="relative z-10" data-id="element-1047">
          <p className="text-[#CC0000] font-bold text-sm uppercase tracking-widest mb-3" data-id="element-1048">
            Our Services
          </p>
          <h1 className="text-4xl sm:text-5xl font-black text-white" data-id="element-1049">
            🩹 Flat Tire Repair
          </h1>
          <div className="w-12 h-0.5 mx-auto mt-4 mb-4" style={{
          background: '#FECB00'
        }} data-id="element-1050" />
          <p className="text-gray-300 text-base max-w-xl mx-auto" data-id="element-1051">
            Quick, reliable, and affordable repair to get you back on the road
            fast.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-1052">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-1053">
          <div data-id="element-1054">
            <h2 className="text-2xl sm:text-3xl font-black text-black mb-5" data-id="element-1055">
              Back on the Road in Minutes
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5" data-id="element-1056">
              A flat tire doesn't have to ruin your day. At Ameritech Tires, we
              specialize in fast, professional flat tire repair — most repairs
              are completed in under 30 minutes. We assess every flat to
              determine whether it can be safely repaired or needs replacement.
            </p>
            <p className="text-gray-600 leading-relaxed" data-id="element-1057">
              Not all flats require a new tire. A puncture in the tread area can
              often be repaired safely and affordably. Our technicians follow
              industry-standard repair procedures to ensure your repaired tire
              is as safe as a new one. Walk-ins always welcome — no appointment
              needed.
            </p>
          </div>

          {/* What's Included */}
          <div className="bg-[#F5F5F5] rounded-lg p-8" data-id="element-1058">
            <h3 className="font-black text-black text-xl mb-6" data-id="element-1059">
              What's Included
            </h3>
            <ul className="space-y-4" data-id="element-1060">
              <li className="flex items-start gap-3" data-id="element-1061">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1062" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1063">
                  Full tire inspection to assess repairability
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1064">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1065" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1066">
                  Puncture removal and industry-standard patch repair
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1067">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1068" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1069">
                  Valve stem inspection and replacement if needed
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1070">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1071" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1072">
                  Tire remounting and balancing after repair
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1073">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1074" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1075">
                  Inflation to correct PSI specification
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1076">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1077" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1078">
                  Honest assessment — we'll tell you if replacement is safer
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why It Matters */}
      <section className="w-full bg-[#F5F5F5] py-16 px-4 sm:px-6 lg:px-8" data-id="element-1079">
        <div className="max-w-5xl mx-auto" data-id="element-1080">
          <h2 className="text-2xl sm:text-3xl font-black text-black mb-6 text-center" data-id="element-1081">
            Repair vs. Replace — We'll Be Honest
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1082">
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1083">
              <div className="text-3xl mb-3" style={{
              background: '#CC0000'
            }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-1084">
                ✅
              </div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1085">
                Repairable
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1086">
                Punctures under ¼ inch in the tread area can typically be
                repaired safely and affordably.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1087">
              <div className="text-3xl mb-3" data-id="element-1088">❌</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1089">
                Not Repairable
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1090">
                Sidewall damage, large punctures, or run-flat damage require
                replacement for your safety.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1091">
              <div className="text-3xl mb-3" data-id="element-1092">⚡</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1093">
                Fast Service
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1094">
                Most flat repairs are done in under 30 minutes. Open 24 hours —
                we're always here when you need us.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Strip */}
      <section className="w-full bg-[#000000] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1095">
        <h2 className="text-2xl sm:text-3xl font-black text-white mb-3" data-id="element-1096">
          Got a Flat? We've Got You.
        </h2>
        <p className="text-gray-400 text-base mb-8 max-w-lg mx-auto" data-id="element-1097">
          Drive in or call us — we're open 24 hours at all 3 DMV locations.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1098">
          <a href="tel:3012549001" className="inline-flex items-center justify-center bg-[#822433] hover:bg-[#6B1D29] text-white font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1099">
            Call (301) 254-9001
          </a>
          <Link to="/locations" className="inline-flex items-center justify-center border-2 border-white text-white hover:bg-white hover:text-black font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1100">
            Find a Location
          </Link>
        </div>
      </section>
    </div>;
}